import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css']
})
export class ConfigurationComponent implements OnInit {

    // Tab management
  activeTab: string = 'container-type-config';
  
  // Tab configuration
  tabs = [
    {
      id: 'container-type-config',
      label: 'Tipos de Contenedor',
      icon: 'nc-icon nc-bullet-list-67',
      description: 'Ver y gestionar todos los tipos de contenedor'
    },
  ];

  constructor() { }

    ngOnInit(): void {
    // Initialize with container type config tab
    this.activeTab = 'container-type-config';
  }

  /**
   * Switch to a specific tab
   * @param tabId - The ID of the tab to activate
   */
  switchTab(tabId: string): void {
    this.activeTab = tabId;
  }

  /**
   * Check if a tab is currently active
   * @param tabId - The ID of the tab to check
   * @returns true if the tab is active
   */
  isActiveTab(tabId: string): boolean {
    return this.activeTab === tabId;
  }
}
